module.exports = __webpack_public_path__ + "static/media/Brakes-red.6fc9b721.svg";